<script setup lang="ts">
import { ref, watch } from 'vue'
import { useUserStore } from '@/stores/user';
import { useFormStore } from '@/stores/form';

const userStore = useUserStore()
const formStore = useFormStore()

const usernote=ref('')
const last5 = ref('')
const note = ref('')
const selectedPlan = ref('')  // 使用者選擇的方案

const firstPurchase = ref(true) // 是否為第一次購買，勾選會加2600
const ExPackagePrice = ref(2800) // 2025成本


// { label: '伸展支架 $300', value: '伸展支架', amount: 300 },
//   { label: 'QR無線掃碼槍 $800', value: '掃碼槍', amount: 800 },
//   { label: '4K鏡頭(台廠) $3500', value: '4K台鏡頭', amount: 3500 },
//   { label: '4K鏡頭(陸廠) $2800', value: '4K陸鏡頭', amount: 2800 }, 


const plans = [
  { label: '4K鏡頭 $3500', value: '4K鏡頭', amount: 3500 },
  { label: '月繳 $800  1個月', value: '1個月', amount: 800 },
  { label: '月繳 $800  2個月', value: '2個月', amount: 1600 },
  { label: '月繳 $800  3個月', value: '3個月', amount: 2400 },
  { label: '月繳 $800  4個月', value: '4個月', amount: 3200 },
  { label: '月繳 $800  5個月', value: '5個月', amount: 4000 },
  { label: '月繳 $800  6個月', value: '6個月', amount: 4800 },
  { label: '月繳 $800  7個月', value: '7個月', amount: 5600 },
  { label: '月繳 $800  8個月', value: '8個月', amount: 6400 },
  { label: '月繳 $800  9個月', value: '9個月', amount: 7200 },
  { label: '月繳 $800 10個月', value: '10個月', amount: 8000 },
  { label: '月繳 $800 11個月', value: '11個月', amount: 8800 },
  { label: '年繳 $9600 1年', value: '1年', amount: 9600 }, 
]


function gologinorvideo() {
  cleanUserInput()
  formStore.switchForm('login')
}

function cleanUserInput() {
  last5.value = ''
  note.value = ''
  selectedPlan.value = ''
  
  firstPurchase.value = false
}

watch([selectedPlan, firstPurchase], ([newPlan, isFirst]) => {
  const plan = plans.find(p => p.value === newPlan)
  if (plan) {
    const total = isFirst ? plan.amount + ExPackagePrice.value : plan.amount
    note.value = `匯款金額：${total} 元`
  } else {
    note.value = ''
  }
})


async function doTransfer() {
  if (!selectedPlan.value) {
    alert('請選擇付款方案')
    return
  }

  if (last5.value.length !== 5) {
    alert('請正確填寫匯款帳號後五碼')
    return
  }

  // 計算最終匯款金額，若為第一次購買，加2600
  const amount = plans.find(p => p.value === selectedPlan.value)?.amount ?? 0
  const totalAmount = firstPurchase.value ? amount + ExPackagePrice.value : amount

  await userStore.TransferInsert(
    userStore.account,
    selectedPlan.value,
    totalAmount,
    last5.value,
    note.value
  )
  // TODO: 這裡可以發送 API or 儲存資料
  // console.log('送出資料：', {
  //   user: userStore.account,
  //   plan: selectedPlan.value,
  //   amount: totalAmount,
  //   last5: last5.value,
  //   note: note.value
  // })

  cleanUserInput()
  alert('請稍後，系統作業中...')
  setTimeout(() => {
    alert('匯款登錄完成，如有任何問題請洽ｌｉｎｅ官方，感謝您．')
  },  3000) 
  formStore.switchForm('login')
 
}
</script>

<template>
  <div class="transfer-container">

    <h3>選擇付款方案</h3>
    <div class="firstbuy">      
      <label style="color: red;">注意事項</label>
      <label>1.零配件請洽官方Line(鏡頭，伸展支架，掃碼槍)</label>
      <label for="firstPurchase">2.首購 專用4K鏡頭，支架，送掃碼槍優惠${{ ExPackagePrice }}元</label>
      <label>3.非首購請取消勾選</label>
      <input type="checkbox" id="firstPurchase" v-model="firstPurchase" />
    </div> 
    <div class="form-group">
      <select v-model="selectedPlan" required style="width: 100%; padding: 10px; font-size: 16px;">
        <option value="" disabled>請選擇方案</option>
        <option v-for="plan in plans" :key="plan.value" :value="plan.value">
          {{ plan.label }}
        </option>
      </select>
    </div>

    <!-- Display the first purchase fee checkbox -->


    <!-- Display the payment amount based on the selected plan -->
    <div v-if="selectedPlan">
      <p style="color: deeppink; font-size: larger;" >匯款金額: 
        {{ 
          (plans.find(p => p.value === selectedPlan)?.amount ?? 0) + (firstPurchase ? ExPackagePrice : 0) 
        }} 元
      </p>
    </div>
    <hr>
    <div class="backinfo">
      <h3>匯款帳戶</h3>
      <label>第一銀行 銀總代號 : 007 </label>
      <label>戶名 : 虔智科技有限公司</label>     
      <label>帳號 : 272-10-150846</label>      
    </div>
    
    <hr>

    <h3>回報匯款資料 註!!!請匯款後填寫</h3>
    <div class="form-group">
      <label>用戶帳號</label>
      <!-- <input type="text" :value="userStore.account" disabled /> -->

      <input type="text" v-model="userStore.account" :disabled="userStore.isLoggedIn" placeholder="請輸入帳號E-Mail 務必檢查" />

      <label for="last5">匯款帳號後五碼 (!請詳細檢查確認無誤)</label>
      <input v-model="last5" id="last5" type="text" maxlength="5" required />

      <label for="note">系統備註</label>
      <textarea v-model="note" id="note" rows="3" disabled></textarea>
      <label for="note">用戶備註</label>
      <textarea v-model="usernote" id="note" rows="5" placeholder="可選填"></textarea>

    </div>

    <!-- Enable/disable button based on conditions -->
    <!-- 修改這一行 -->
    <button :disabled="!selectedPlan || last5.length !== 5 " @click="doTransfer">填寫送出</button>

    <button @click="gologinorvideo">返回</button>
  </div>
</template>

<style scoped>
button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

h3{
  color: deeppink;
}
#agree, #firstPurchase {
  transform: scale(1.5); /* Scale to 150% */
  margin: 10px;
  display: inline; /* Ensures the checkbox stays on the same line */
}

.agreediv, .firstbuy {
  display: inline; 
}

.transfer-container {
  padding: 20px;
  max-width: 500px;
  margin: auto;
  border: 1px solid deeppink;
  border-radius: 8px;
}

.bank-info p {
  margin: 5px 0;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 6px;
  font-weight: bold;
}

input,
textarea,
select {
  border-radius: 10px;
  background-color: black;
  color: white;
  font-size: 18px;
  margin: 10px 0;
  width: 400px;
  padding: 5px;
}

button {
  background-color: deeppink;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin: 5px;
}

.price-display {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
  color: green;
}

.agreement {
  margin-top: 15px;
  font-size: 16px;
}
</style>
